export default "__VITE_ASSET__prw026Lm__"